import React from 'react';

const PIs = (props) => {
    const {list} = props;
    return (
        <div className='container container max-w-xl m-auto flex flex-wrap flex-col md:flex-row items-center justify-center'>
            <div className='w-full lg:w-1/2 p-3'>
            <ul className="font-sans list-reset container m-auto text-grey-darkest">
            {sortNames(list).map((item, index) => 
                <li key={index}
                    className="inline-block border-b border-grey-light flex justify-between items-center py-4">
                    <div className="flex items-start w-full md:w-2/5">
                        <div className="flex-1 overflow-hidden">
                            <div className="font-bold text-left">{item.name}</div>
                        </div>
                    </div>
                    <div className="w-full md:w-1/5"><a className='pl-4 no-underline' href={item.url}>Lab</a></div>
                    <label className="w-full font-thin md:w-3/5 text-left">{item.university}</label>
                </li>
            )}
            </ul>
        </div>
        </div>
        
    );
}

export default PIs;

function sortNames(list) {
    const listWithLastName = list.map(entry => {
        const lastName = extractLastName(entry.name);
        const tmp = {...entry};
        tmp.lastName = lastName;

        return tmp;
    })

    const sortedList = listWithLastName.sort(compareValues('lastName'));
    return sortedList;
}

function extractLastName(fullname) {
    const withoutDegree = fullname.split(',')[0];
    const lastName = withoutDegree.split(' ').slice(-1)[0] ;
    return lastName;
}
function compareValues(key, order='asc') {
    return function(a, b) {
      if(!a.hasOwnProperty(key) || 
         !b.hasOwnProperty(key)) {
          return 0; 
      }
      
      const varA = (typeof a[key] === 'string') ? 
        a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string') ? 
        b[key].toUpperCase() : b[key];
        
      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? 
        (comparison * -1) : comparison
      );
    };
  }
  